import { createModalStore } from '@/shared/lib/modal';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

import { LimitedFeature, PlanCategoriesKeys } from '../lib/types';

type UseUpgradePlanModalProps = {
  fromTrialPreview?: boolean;
  limitedFeature?: LimitedFeature;
  plan?: PlanCategoriesKeys;
  pricingEntryPoint?: PricingEntryPoint;
};

const initialState: UseUpgradePlanModalProps = {
  fromTrialPreview: false,
  limitedFeature: undefined,
  pricingEntryPoint: 'unattributed_paywall',
};

export const useUpgradePlanModalStore = createModalStore<UseUpgradePlanModalProps>(initialState, false);
